export default function auth({ next, router, store }) {
    if (!store.getters.auth.isAuthenticated) {
        return router.push({ name: 'home' });
    }

    return next();
}